<script>
import Address from "@/models/address";

export default {
  name: "AddressForm",
  data(){
    return{
      rules: {
        required: value => !!value || this.$t('required')
      }
    }
  },
  props:{
    address:{
      type:Address,
      required:true
    },
    variant:{
      type:String,
      default:"outlined"
    }
  },
  computed:{
    addressComputed:{
      get(){
        return this.address;
      },
      set(value) {
        this.$emit('update:address', value);
      }
  }
  }
}
</script>

<template>
  <v-text-field
      :variant="variant"
      autocomplete="address-line1"
      type="text"
      :rules="[rules.required]"
      :label="$t('address.streetAndNumber')+'*'"
      v-model="addressComputed.street"
  />


  <v-row>
    <v-col cols="4">
      <v-text-field
          :variant="variant"
          autocomplete="postal-code"
          type="text"
          :label="$t('address.zip')"
          :rules="[rules.required]"
          v-model="addressComputed.postcode"
      />
    </v-col>
    <v-col>
      <v-text-field
          :variant="variant"
          autocomplete="address-level2"
          type="text"
          :label="$t('address.city')+'*'"
          :rules="[rules.required]"
          v-model="addressComputed.city"
      />

    </v-col>

  </v-row>
  <v-text-field
      :variant="variant"
      autocomplete="country-name"
      type="text"
      :label="$t('address.country')+'*'"
      :rules="[rules.required]"
      v-model="addressComputed.country"
  />
</template>

<style scoped>

</style>